import React from 'react';
import { useLocale } from 'locale';
import ChevronDownIcon from 'assets/svg/chevron-down.svg';
import ChevronUpIcon from 'assets/svg/chevron-up.svg';
import * as Styled from './styled';
import { useSpring, animated } from 'react-spring';

interface DescriptionWithToggleProps {
  description: string;
}

export const DescriptionWithToggle: React.FC<DescriptionWithToggleProps> = (props) => {
  const { description } = props;
  const { t } = useLocale();
  const ref = React.useRef(null);
  const [ isToggled, setToggled ] = React.useState(false);
  const [ style, animate ] = useSpring(() => ({ height: '100px', marginBottom: '0px' }));

  React.useEffect(() => {
    animate({
      height: (isToggled ? ref.current.offsetHeight : 100) + 'px',
      marginBottom: (isToggled ? 16 : 0) + 'px',
    });
  }, [ animate, isToggled ]);

  return (
    <Styled.ToggleRoot data-auto="description">
      <Styled.Text weight="bold">{t('unitPage.description.header')}</Styled.Text>
      <animated.div
        style={{
          overflow: 'hidden',
          marginTop: '16px',
          ...style,
        }}
      >
        <Styled.DescriptionText ref={ref}>{description}</Styled.DescriptionText>
      </animated.div>
      <Styled.ToggleBtn data-auto="description-toggle" onClick={() => setToggled(prev => !prev)}>
        {t('unitPage.description.toggle', { status: isToggled })}
        {isToggled ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Styled.ToggleBtn>
    </Styled.ToggleRoot>
  );
};
